import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/main-menu.jsx");
